import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";
import { Functions } from "../../../helpers/Functions.jsx";

const CambiarTasaModal = ({ show, onClose, onSave, showCreate, title, initDataTasa }) => {
    const { handleSubmit: handleSubmitModal, reset: resetModal, register: registerModal, setValue : setValueModal, getValues: getValuesModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
    useEffect(() => {
        resetModal();
        if (initDataTasa !== CONFIGURACIONES.INIT.NULL) {
            setValueModal('tasaActual', initDataTasa.tasaActual);
            setValueModal('tasaPropuesta', initDataTasa?.tasaPropuesta);
        }
    }, [initDataTasa]);

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(onSave)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <label htmlFor="tasaActual" className="control-label col-form-label">Tasa Actual <span className="text-danger">*</span></label>
                            
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="tasaActual"
                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                        id="tasaActual"
                                        {...registerModal("tasaActual", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">%</span>
                                    </div>
                                </div>
                                <small className="invalid-feedback"> { errorsModal.tasaActual && errorsModal.tasaActual.message }</small>
                            </div>

                            <div className="col-sm-12 col-md-6">
                                <label htmlFor="tasaPropuesta" className="control-label col-form-label">Tasa Propuesta <span className="text-danger">*</span></label>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="tasaPropuesta"
                                        id="tasaPropuesta"
                                        {...registerModal("tasaPropuesta", {
                                            valueAsNumber: true,
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            max: {
                                                value: CONFIGURACIONES.INIT.TASA.MAX,
                                                message: CONFIGURACIONES.INIT.TASA_MESSAGES.MAX
                                            },
                                            min: {
                                                value: CONFIGURACIONES.INIT.TASA.MIN,
                                                message: CONFIGURACIONES.INIT.TASA_MESSAGES.MIN
                                            }
                                        })}
                                    />

                                    <div className="input-group-append">
                                        <span className="input-group-text">%</span>
                                    </div>
                                </div>
                                <small className="invalid-feedback"> { errorsModal.tasaPropuesta && errorsModal.tasaPropuesta.message }</small>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect">
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default CambiarTasaModal;
